

























































// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, Hub, SortDirection } from 'aws-amplify'
import {
  IChecklistItem
} from '../graphql/checklist-item/interfaces/checklist-item'
import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import TranslateDialog from '@/components/dialogs/Translate.vue'
import Draggable from 'vuedraggable'
import { GenerateLocaleDict } from '../lib/Locale'
import { mutateSnackbar } from '@/store/snackbar'
import { query as tenant } from '@/store/tenant'
import { Checklist, ChecklistItem } from '../models/index'
import { copyFromDataStore, HubEvents } from '@/amplify'

@Component<DistrictChecklistEditView>({
  components: {
    Draggable,
    AddDialog,
    ConfirmDialog,
    TranslateDialog
  },
  // @ts-ignore
  metaInfo() {
    let name = ``
    if (this.checklist?.title?.de) {
      name = this.checklist.title.de
    }
    return {
      title: this.$t('checklistEdit.titleNamed', {
        name
      })
    }
  },
  apollo: {
    tenant
  }
})
export default class DistrictChecklistEditView extends Vue {
  checklist = null
  checklistItems = []
  checklistItemsSubscription = null
  isLoading = false
  saving = false

  get districtId() {
    return this.$route.params.districtId
  }

  get checklistId() {
    return this.$route.params.checklistId
  }

  dispatchUpdateEventToHub(event) {
    Hub.dispatch('ListEdit', {
      event,
      data: {
        model: 'Checklist',
      }
    })
  }

  @Watch('tenant')
  async recreate() {
    this.getChecklist()
    this.subscribeToChecklistItems()
  }

  @Watch('checklistId')
  refetchChecklist() {
    this.getChecklist()
    this.subscribeToChecklistItems()
  }

  created() {
    this.refetchChecklist()
  }

  destroyed() {
    this.checklistItemsSubscription.unsubscribe()
  }

  async getChecklist() {
    // this.isLoading = true
    try {
      const query = await DataStore.query(Checklist, this.checklistId)
      if (!query) throw new Error('Page not found')
      this.checklist = copyFromDataStore(query)
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
  }

  subscribeToChecklistItems() {    
    if (!this.tenant) return;
    this.checklistItemsSubscription !== null && this.checklistItemsSubscription.unsubscribe();
    this.checklistItemsSubscription = DataStore.observeQuery(
      ChecklistItem,
      p => p.and(p => [
        p.tenant.eq(this.tenant.id),
        p.checklistID.eq(this.checklistId),
      ]),
      {
        sort: s => s.sortPosition(SortDirection.ASCENDING)
      }
    ).subscribe(({ items }) => {
      this.checklistItems  = Array.from(items)
      setTimeout(() => {
        this.isLoading = false
      }, 250)
    })
  }

  async addItem(title: string) {
    if (!this.checklistItems) return
    this.isLoading = true
    try {
      await DataStore.save(
        new ChecklistItem({
          contentList: {
            what: GenerateLocaleDict({ de: title })
          },
          date: {},
          sortPosition: this.checklistItems.length,
          tenant: this.tenant?.id,
          checklistItemsId: this.checklistId,
          checklistID: this.checklistId,
        })
      )
      mutateSnackbar(
        { text: String(`Todo erstellt.`), color: `success` },
        this.$apollo
      )
      this.dispatchUpdateEventToHub(HubEvents.itemAdd)
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    setTimeout(() => {
      this.isLoading = false
    }, 250)
  }

  async deleteItem(item: IChecklistItem) {
    try {
      await DataStore.delete(ChecklistItem, d => d.id.eq(item.id))
      mutateSnackbar(
        { text: String(`Todo gelöscht.`), color: `success` },
        this.$apollo
      )
      this.dispatchUpdateEventToHub(HubEvents.itemDelte)
    } catch (err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
  }

  async saveChecklistItemOrder() {
    if (this.checklistItems.length <= 0) return
    try {
      this.isLoading = true
      this.checklistItemsSubscription.unsubscribe()
      for (const [index, checklist] of this.checklistItems.entries()) {
        await DataStore.save(
          ChecklistItem.copyOf(checklist, updated => {
            updated.sortPosition = index
          })
        )
      }
    } catch(err) {
      mutateSnackbar(
        { text: JSON.stringify(err.message), color: `error` },
        this.$apollo
      )
    }
    this.dispatchUpdateEventToHub(HubEvents.orderSave)
    this.subscribeToChecklistItems()
  }

  async saveChecklist() {
    this.isLoading = true
    try {
      await DataStore.save(
        Checklist.copyOf(
          await DataStore.query(Checklist, this.checklistId),
          updated => {
            for (const [key, value] of Object.entries(this.checklist)) {
              updated[key] = value
            }
          }
        )
      )
      this.dispatchUpdateEventToHub(HubEvents.itemUpdate)
      await this.saveChecklistItemOrder()
      mutateSnackbar(
        { text: String(`Erfolgreich gespeichert`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    setTimeout(() => {
      this.isLoading = false
    }, 250)
  }
}
